import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row d-flex justify-content-evenly w-100 mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 col-sm-12 col-lg-6 col-xl-3 text-center"
}
const _hoisted_3 = { class: "mb-0 fw-normal" }
const _hoisted_4 = { class: "fw-bold text-uppercase mb-0" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "col-12 col-lg-6 col-xl-3 text-center mt-3 mt-md-0"
}
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "fw-bold text-uppercase mb-0" }
const _hoisted_9 = { class: "text-uppercase" }
const _hoisted_10 = {
  key: 2,
  class: "col-12 col-lg-6 col-xl-3 text-center"
}
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "text-uppercase fw-bold mb-0" }
const _hoisted_13 = {
  key: 3,
  class: "col-12 col-lg-6 col-xl-3 text-center mt-3"
}
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "fw-bold text-uppercase mb-0" }
const _hoisted_16 = { class: "fw-bold text-uppercase mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.navigation.ubicacion?.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.t('titles.infoTitles.ubic')), 1),
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.navigation.ubicacion?.title), 1),
          _createElementVNode("h6", {
            class: "text-uppercase",
            innerHTML: _ctx.navigation.ubicacion?.subtitle
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    (_ctx.navigation.vehiculo?.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.t('titles.infoTitles.veh')), 1),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.navigation.vehiculo?.title), 1),
            _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.navigation.vehiculo?.subtitle), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.navigation.actividad?.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.t('titles.infoTitles.actv')), 1),
            _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.navigation.actividad?.title), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.navigation.turno?.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_14, _toDisplayString(_ctx.t('titles.infoTitles.turn')), 1),
            _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.navigation.date?.concatenado), 1),
            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.navigation.turno?.title), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}